const notificationQueryKeys = {
  all: ["notifications"] as const,
  info: (userId: string, subject?: string) =>
    [...notificationQueryKeys.all, "info", userId, subject] as const,
};

export default notificationQueryKeys;
